import { render, staticRenderFns } from "./AddBetana.vue?vue&type=template&id=63e06016&scoped=true&"
import script from "./AddBetana.vue?vue&type=script&lang=js&"
export * from "./AddBetana.vue?vue&type=script&lang=js&"
import style0 from "./AddBetana.vue?vue&type=style&index=0&id=63e06016&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e06016",
  null
  
)

export default component.exports